import { sheetV1 } from "@otto-ec/otto-components/sheet";

export function getOcActiveSheet(): sheetV1 | undefined {
  return sheetV1.current.get()?.instance;
}
